module.exports = __webpack_public_path__ + "static/img/logo.43ae046d.png";